import { Event } from 'inscreva-sse-models';

import { Session } from './session';

export class SessionAdmin extends Session {
  event: Event;

  constructor() {
    super();
    this.event = {} as Event;
  }

  static fromJson<T extends Session = SessionAdmin>(json: Partial<SessionAdmin>): T {
    const session = new SessionAdmin();
    session.user = json.user;
    session.client = json.client;
    session.companies = json.companies;
    session.company = json.company;
    return session as unknown as T;
  }
}
